import { motion } from "framer-motion";
import { Star, HelpCircle } from "lucide-react";
import { BOMB } from "../../game/config";

const faceStyle = (status, isBomb) => {
  if (status === "correct") return "bg-gradient-to-br from-emerald-400 to-teal-500 shadow-[0_0_24px_rgba(16,185,129,0.45)]";
  if (status === "wrong") return "bg-gradient-to-br from-amber-400 to-orange-500 shadow-[0_0_24px_rgba(245,158,11,0.45)]";
  if (status === "bomb") return "bg-gradient-to-br from-rose-500 to-red-600 shadow-[0_0_28px_rgba(244,63,94,0.6)]";
  if (isBomb) return "bg-gradient-to-br from-rose-400 to-fuchsia-500";
  return "bg-gradient-to-br from-sky-400 to-indigo-500";
};

export const Tile = ({ index, value, status, faceUp, onClick, disabled, category }) => {
  const isBomb = value === BOMB;
  const shake = status === "wrong" ? { x: [0, -8, 8, -6, 6, 0] } : status === "bomb" ? { scale: [1, 1.18, 1] } : {};
  return (
    <motion.button
      data-testid={`tile-item-${index}`}
      data-value={isBomb ? "bomb" : value}
      data-faceup={faceUp ? "true" : "false"}
      onClick={() => onClick(index)}
      disabled={disabled}
      initial={{ opacity: 0, y: 16, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1, ...shake }}
      transition={{ delay: Math.min(index * 0.02, 0.3), duration: 0.3 }}
      whileHover={disabled ? {} : { y: -4 }}
      whileTap={disabled ? {} : { scale: 0.93 }}
      className="tile-scene aspect-square w-full rounded-2xl focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan-300/60"
    >
      <div className={`tile-inner ${faceUp ? "is-flipped" : ""}`}>
        <div className="tile-face tile-back rounded-2xl border border-white/15 bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-700">
          <HelpCircle className="h-1/3 w-1/3 text-white/35" strokeWidth={2.5} />
        </div>
        <div className={`tile-face tile-front rounded-2xl border border-white/25 ${faceStyle(status, isBomb)}`}>
          {isBomb ? (
            <Star className="h-1/2 w-1/2 fill-yellow-300 text-yellow-200 drop-shadow" />
          ) : (
            <span className="grid h-full w-full place-items-center text-2xl text-white drop-shadow sm:text-4xl">{category.render(value)}</span>
          )}
        </div>
      </div>
    </motion.button>
  );
};
